import { slugs } from '@/constants/slugs'

export const GUILD_AGE_RECOMMENDATIONS = {
  [slugs.sketch]: {
    ageText: 'Ages 8+',
    description:
      'Contains scary chalk and crayon monsters and music, 1 sh*t, 5 h*ll, 2 dumb*ss, other mildly crude language.',
  },
} as const
